import * as React from 'react';

const NotFoundPage = () => (
    <div>
        <h1>404: Page not found.</h1>
        <p>
            You've hit the void. <a href="/">Go back.</a>
        </p>
    </div>
);

export default NotFoundPage;
